<template>
  <div class="content">
    <div class="bodycontent">
      <div class="act-main-title">
        <div
          :class="[
            tablist.index == idx
              ? 'active act-main-title-item'
              : 'act-main-title-item'
          ]"
          v-for="(item, idx) in tablist.arr"
          :key="idx"
          @click="tablist.index = idx"
        >
          {{ item }}
        </div>
      </div>
      <div class="act-header">
        <el-button
          @click="goAddCon"
          class="mybtn"
          type="primary"
          icon="el-icon-plus"
          >创建新活动</el-button
        >
        <div class="act-info">
          <label>活动信息</label>
          <el-input v-model="searchAll.act_info">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="act-info">
          <label>有效期</label>
          <el-input v-model="searchAll.time" disabled>
            <i slot="suffix" class="el-input__icon el-icon-date"></i>
          </el-input>
        </div>
        <div class="act-info">
          <label>状态</label>
          <el-select v-model="searchAll.now_status" placeholder="请选择">
            <el-option label="item.label" value="item.value"> </el-option>
          </el-select>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="setHeader"
      >
        <el-table-column prop="date" label="活动名称" width="180">
        </el-table-column>
        <el-table-column prop="name" label="有效期" width="180">
        </el-table-column>
        <el-table-column prop="address" label="适用门店"> </el-table-column>
        <el-table-column prop="address" label="状态"> </el-table-column>
        <el-table-column prop="address" label="操作">
          <template>
            <el-button type="text">编辑</el-button>
            <el-button type="text">停用</el-button>
            <el-button type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="my-page"
        background
        layout="prev, pager, next"
        :total="1000"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tablist: {
        index: 0,
        arr: ["活动列表"]
      },
      searchAll: {
        act_info: "",
        now_status: "",
        time: ""
      },
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ]
    };
  },
  methods: {
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    goAddCon() {
      this.$router.push("/apply/newVip/13/business/addActivity");
    }
  }
};
</script>
<style scoped>
.el-input.is-disabled >>> .el-input__inner {
  background-color: #ffffff !important;
  cursor: pointer;
}
.el-pagination .is-background .el-pager li:not(.disabled).active {
  background-color: rgba(47, 84, 235, 1);
  color: #fff;
}
</style>
<style lang="scss" scoped>
@import "../sub_com";
.bodycontent {
  background: #ffffff;
  padding: 0px 27px 0;
}
.act-main-title {
  width: 100%;
  height: 60px;
  display: flex;
  .act-main-title-item {
    min-width: 88px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.09);
  }
  .active {
    color: rgba(47, 84, 235, 1);
    border-bottom: 1px solid rgba($color: #2f54eb, $alpha: 1);
  }
}
.act-header {
  width: 100%;
  height: 78px;
  max-height: 78px;
  display: flex;
  align-items: center;
  .mybtn {
    background-color: #2f54eb;
  }
  .act-info {
    width: 20%;
    display: flex;
    align-items: center;
    margin-left: 30px;

    label {
      display: block;
      min-width: 60px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
      margin-right: 20px;
    }
  }
}
.my-page {
  margin-top: 20px;
  float: right;
}
</style>
